"use client";

import React, { ReactNode } from "react";

interface ShimmerProps {
  children: ReactNode;
  gap?: string | number;             // space between shimmer items
  direction?: "row" | "column";      // flex direction
  align?: "start" | "center" | "end" | "stretch";
  justify?: "start" | "center" | "end" | "between" | "around" | "evenly";
  className?: string;
}

export default function Shimmer({
  children,
  gap = "1rem",
  direction = "column",
  align = "start",
  justify = "start",
  className = "",
}: ShimmerProps) {
  const justifyMap: Record<string, string> = {
    start: "justify-content-start",
    center: "justify-content-center",
    end: "justify-content-end",
    between: "justify-content-between",
    around: "justify-content-around",
    evenly: "justify-content-evenly",
  };

  const alignMap: Record<string, string> = {
    start: "align-items-start",
    center: "align-items-center",
    end: "align-items-end",
    stretch: "align-items-stretch",
  };

  return (
    <div
      className={`d-flex flex-${direction} ${justifyMap[justify]} ${alignMap[align]} ${className} w-100 h-100`}
      style={{ gap }}
    >
      {children}
    </div>
  );
}
